import GeneralTableComponent from 'components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  RequestStatus,
} from 'components/GeneralFormView/types';
import {
  translate,
} from 'helperFunctions/translation';
import {
  inject,
  observer,
  useObserver,
} from 'mobx-react';
import { WheelWinner } from 'mobx-store/storeInterfaces/wheelFortuneInterface';
import React, {
  useEffect, useState,
} from 'react';
import {
  useHistory,
  useLocation,
  useParams,
} from 'react-router-dom';
import {
  EventWinnersProps, Pagintation,
} from '../types';
import moment from 'moment';
import queryString, { ParsedQuery } from 'query-string';
import ButtonState from 'components/ButtonStateComponent';
import { saveAs } from 'file-saver';
import * as style from './styles.module.scss';
import Spinner from 'components/Spinner';
import SnackBarComponent from 'components/SnackBarComponent/SnackBarComponent';
const DEFAULT_PAGE_SIZE = 50;
const DEFAULT_PAGE_NUMBER = 1;

const WheelEventWinnersScreen: React.FC<EventWinnersProps> = observer(
  inject('wheelFortuneStore')((props: EventWinnersProps) => {

  const mapPagintaion = (options: ParsedQuery<string>): Pagintation => {
    const paginationObject = {
      pageNumber: options?.pageNumber ? +options.pageNumber : DEFAULT_PAGE_NUMBER,
      pageSize: options?.pageSize ? +options.pageSize : DEFAULT_PAGE_SIZE
    };
    const search = new URLSearchParams({
      pageNumber: `${paginationObject?.pageNumber}`, pageSize: `${paginationObject?.pageSize}`
    }).toString();
    history.push({
      pathname: `/wheel-fortune/events/${+params.eventId}/winners`,
      search: `?${search}`
    });
    return paginationObject;
  }
    const {
      wheelFortuneStore,
    } = props;
    const params = useParams<{eventId: string}>();
    const [pagintation, setPagination] = useState<Pagintation>({
      pageNumber: DEFAULT_PAGE_NUMBER,
      pageSize: DEFAULT_PAGE_SIZE
    });
    const location = useLocation();   
    const history = useHistory();
 
    const [winnersLength, setWinnersLength] = useState(0);
    const [loading, setLoading] = useState(false);
    
    useEffect(() => {
      const queryValues = queryString.parse(location.search);
      setPagination(mapPagintaion(queryValues));
    }, [location.search]);

    useEffect(() => {
      history.listen(location => {
          if(history.action === 'POP') {
            history.push('/wheel-fortune/events');
          }
      });
    }, []);
    const onInit = async () => {
      await wheelFortuneStore.getWheelEventWinners(+params.eventId, pagintation);
      await wheelFortuneStore.getWheelEventById(+params.eventId);
      setWinnersLength(wheelFortuneStore.winnersCount);
    };
    useEffect(() => { onInit(); }, [ pagintation ]);

    const generateCsv = async () => {
      try {
        setLoading(true);
        const csv = await wheelFortuneStore.getWheelEventWinnersCsv(+params.eventId);
        saveAs(csv, `winners:${Date.now()}`)
      }catch(err) {
        console.log("errorrr", err);
      } finally {
        setLoading(false);
      }
    };
    const previousPage = () => {
      mapPagintaion({pageNumber: `${--pagintation.pageNumber}`})
    };

    const nextPage = () => {
      mapPagintaion({pageNumber: `${++pagintation.pageNumber}`})
    };

    const retryDeglawyPoints = async (index: number, key: string) => {
      try {
        wheelFortuneStore.retryPointsStatus[index] = RequestStatus.LOADING;
        const winner = wheelFortuneStore.winners[index];
        await wheelFortuneStore.retryDeglawyPoints(wheelFortuneStore.event.eventId, +winner.wheelWinnerId, 'en');
        wheelFortuneStore.retryPointsStatus[index] = RequestStatus.SUCCESS;
        SnackBarComponent.getInstance().openSnackbar('Points accumlated successfully', 8000, 'success');
      } catch (errorBody) {
        let error = (errorBody as any)?.response?.data?.message || 'Please try again later';

        wheelFortuneStore.retryPointsStatus[index] = RequestStatus.FAILED;
        SnackBarComponent.getInstance().openSnackbar(error, 8000, 'error');
      }
    };



    const EventWinnersTable = observer((WinnerTableProps: { state: RequestStatus }) => (
      <GeneralTableComponent
        emptyMessage={translate('settingsListNoSettingsMessage')}
        title={wheelFortuneStore.event?.title + " Wheel"}
        tableHeader={[
          {
            title: '#'
          },
          {
            title: 'MembershipId',
          },
          {
            title: 'Prize value',
          },
          {
            title: 'Spin At'
          },
          {
            title: 'Retry'
          }
        ]}
        tableData={
            wheelFortuneStore.winners.map((w: WheelWinner, index: number) => {
              return {
                ...w,
                index: (winnersLength - index) - (pagintation.pageSize * (pagintation.pageNumber - 1)),
                createdAt: moment(new Date(w.createdAt)).format("YYYY-MM-DD HH:mm"),
                Retry: wheelFortuneStore.retryPointsStatus[index] === RequestStatus.LOADING ? <Spinner size={25} /> : "Retry"
              };
            })
          }
        tableCellTypes={[
          {
            key: 'index',
            cellType: 'Text'
          },
          {
            key: 'membershipId',
            cellType: 'Text',
          },
          {
            key: 'value',
            cellType: 'Text',
          },
          {
            key: 'createdAt',
            cellType: 'Text'
          },
          {
            key: 'Retry',
            cellType: 'Button',
            onClick: retryDeglawyPoints,
            disabled: (index) => wheelFortuneStore.retryPointsStatus[index] === RequestStatus.LOADING
          }
        ]}
        loadingStatus={[
          WinnerTableProps.state,
        ]}
        hadPagination={true}
        paginationAction={{
          handleClickLeftArrow: () =>  previousPage(),
          handleClickRightArrow: () => nextPage(),
          pageNumber: pagintation.pageNumber,
          totalNumberOfPages: Math.ceil(wheelFortuneStore.winnersCount / pagintation.pageSize),
      }}
      />
    ));
    return useObserver(() => (
      <>
      <div className={style.right}>
        <ButtonState disabled={false} loading={loading} onClick={() => generateCsv()}>
            Download csv
        </ButtonState>
      </div>
        <EventWinnersTable state={wheelFortuneStore.status} />
      </>
    ));
  }),
);

export default WheelEventWinnersScreen;
